import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'UrlService'
const host = servicesConfig.Urls
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const UrlService = {
  createShortUrl: async (originalUrl: string, shortBaseUrl?: string) =>
    request().post(`/upsert`, {
      originalUrl,
      shortBaseUrl,
    }).then(responseBody)
}

export default UrlService
